import React from 'react';
import { AlertCircle, Wallet } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';

export const InsufficientBalanceModal = ({ open, message, onClose, onTopUp }) => {
  const { t } = useI18n();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('insufficientBalanceTitle')}
      panelClassName="max-w-md rounded-[1.75rem] p-5"
      contentClassName="mb-4"
      titleClassName="text-base"
    >
      <div className="space-y-5">
        <div className="flex gap-3 rounded-2xl border border-rose-200/80 bg-rose-50/70 p-4 dark:border-rose-500/20 dark:bg-rose-500/10">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-100 text-rose-600 dark:bg-rose-500/20 dark:text-rose-200">
            <AlertCircle size={18} />
          </span>
          <p className="text-sm leading-6 text-muted">
            {message?.trim() || t('insufficientBalanceFallback')}
          </p>
        </div>

        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <Button type="button" variant="secondary" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button type="button" onClick={onTopUp}>
            <Wallet size={16} aria-hidden />
            {t('upgradePlan')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
